module.exports = __webpack_public_path__ + "img/P150T_weapon_71.0c7b1b78.png";